// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/css/hotBox.css
// module id = 659
// module chunks = 177